import { FC, ReactElement } from 'react';

import './CartItemFormSkeletons.scss';

interface CartItemFormSkeletonsProps {
    className?: string;
}

export const CartItemFormSkeletons: FC<CartItemFormSkeletonsProps> = ({
    className = '',
}): ReactElement => {
    const items = [1, 2, 3];

    return (
        <ul className={`cart-item-form-skeletons ${className}`}>
            {items.map(skeleton => (
                <li key={skeleton} className="cart-item-form-skeletons__item">
                    <div className="cart-item-form-skeletons__image" />
                </li>
            ))}
        </ul>
    );
};
